<template>
  <div class="SearchFilter">
    <div
      v-if="!queryGroup"
      class="SearchFilter-facetParent card is-rounded has-border Block "
    >
      <h5
        class="SearchFilter-title"
        @click.prevent="toggleList"
      >
        {{ title }}
      </h5>
      <ul v-if="hasFilters">
        <li
          v-for="(group) in tags.groups"
          :key="group.name"
          class="SearchFilter-facetTitle"
          @click.prevent="openGroup(group)"
        >
          <a
            :href="group.url"
            :class="[{ 'is-disabled': isValueDisabled(group) || isDisabled }, 'SearchFilter-link']"
            :rel="anchorRelAttributeValue(group)"
            @click.prevent="openGroup(group)"
          >
            {{ group.name }}
            <span
              v-if="showGroupCount(group)"
              class="SearchFilters-count"
            >
              ({{ group.count }})
            </span>
          </a>
        </li>
      </ul>
      <ul v-else>
        <li
          v-for="index in fallbackCount"
          :key="index"
          class="SearchFilter-facetTitle"
        >
          <a
            href="#"
            class="is-disabled SearchFilter-link"
            @click.prevent
          >
            <span class="placeholder">&nbsp;</span>
          </a>
        </li>
      </ul>
    </div>

    <div
      v-if="queryGroup && computedGroups.length > 0"
      class="SearchFilter-facetChild card is-rounded Block Block--stroke"
    >
      <a
        :href="computedBackUrlForSelectedParent"
        class="FacetChild-back"
        @click.prevent="resetCurrentGroup()"
      >
        <i class="fa fa-angle-left" />
        Back
      </a>

      <h5 class="FacetChild-title">
        {{ computedTitle }}
      </h5>
      <ul class="">
        <li
          v-for="(tag) in computedGroups"
          :key="tag.name"
          class="Form-field Form-field--checkbox"
        >
          <input
            :id="tag.key"
            v-model="filterQuery"
            :value="tag.key"
            :disabled="isValueDisabled(tag) || isDisabled"
            type="checkbox"
            class="FacetChild-check Form-input"
            @click.prevent="updateQueryInStore(tag)"
          >
          <label
            :class="{ 'is-disabled': isValueDisabled(tag) || isDisabled }"
            :for="tag.key"
            class="FacetChild-label Form-label"
            @click.prevent="updateQueryInStore(tag)"
          >
            <a
              :href="tag.url"
              :rel="anchorRelAttributeValue(tag)"
              class="FacetChild-name"
              @click.prevent
            >
              {{ tag.name }}
              <span
                v-if="showCount"
                class="SearchFilters-count"
              >
                ({{ tag.count }})
              </span>
            </a>

          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import filterQueryUpdateMixin from './filter-component-mixin';

export default {
  mixins: [filterQueryUpdateMixin],

  computed: {
    ...mapState('search', {
      queryGroup(state) {
        return state.query[this.queryKeys.parent];
      },
      loadingState: (state) => state.uiLoadingState,
    }),

    computedTitle() {
      if (this.queryGroup) {
        const currentGroup = this.tags.groups.find((group) => group.key === this.queryGroup);
        if (!currentGroup) {
          return '';
        }

        return currentGroup.name;
      }

      return '';
    },
    computedBackUrlForSelectedParent() {
      if (this.queryGroup) {
        const currentGroup = this.tags.groups.find((group) => group.key === this.queryGroup);
        if (!currentGroup) {
          return '';
        }
        return currentGroup.url_without_filter;
      }
      return '';
    },

    computedGroups() {
      if (this.queryGroup) {
        const parent = this.tags.groups.find((group) => group.key === this.queryGroup);
        if (!parent) {
          return '';
        }
        return this.tags.values.filter((tag) => tag.parent_key === parent.key);
      }

      return this.tags;
    },
  },

  methods: {
    toggleList() {
      this.togglelist = !this.togglelist;
    },
    openGroup(group) {
      if (group.count === 0 && this.showCount !== false) {
        return false;
      }

      this.updateSearchUrl(group.url);

      return this.updateQueryFilters({
        filterValues: group.key,
        filterName: this.queryKeys.parent,
      });
    },

    resetCurrentGroup() {
      this.updateSearchUrl(this.computedBackUrlForSelectedParent);
      this.updateQueryFilters({
        filterValues: false,
        filterName: this.queryKeys.parent,
      });
      this.updateQueryFilters({
        filterValues: [],
        filterName: this.queryKeys.values,
      });
    },

    showGroupCount(group) {
      return (group.count !== false) && (this.showCount === true);
    },
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";

.placeholder {
  background: color('grey', 'lightest');
  display: block;
  //padding: 3px 5px;
}

.SearchFilter-facetTitle {
  margin-bottom: .5rem;
}

.SearchFilterBlock-facetParent {
  a {
    text-decoration: none;
  }

  ul {
  }

  li {
    margin-bottom: 5px;
  }

}

.SearchFilterBlock-facetChild {

}

.FacetChild-back {
  text-decoration: none;
  margin-bottom: .5rem;
  padding-bottom: .5rem;
  border-bottom: 1px solid color('grey', 'light');
  display: block;
}

.FacetChild-title {
  font-size: 18px;
  margin-top: 0;
}

.FacetChild-list {
  max-height: 300px;
  overflow-y: scroll;
}

.FacetChild-label {
  display: flex;

  &::before {
    flex-shrink: 0;
  }
}

.FacetChild-check {
  margin-top: 7px;
  flex: 0 0 12px;
}

  .SearchFilters-count {
    color: color('grey', 'darkest');
    padding-left: 4px;
  }

.is-disabled {
  a {
    cursor: default;
    color:  color('grey');
  }
  cursor: default;
  color:  color('grey');
  .SearchFilters-count,
  .FacetChild-name {
    color: lighten( color('grey'), 10%);
    &::before {
      background:  color('grey');
    }
  }
  &::before {
    background: #e2e0dc !important;
  }
}

</style>
